import { makeStyles, tokens } from '@fluentui/react-components';

export const useCardChallengeLayoutStyles = makeStyles({
  challengeImageBackground: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: tokens.colorBrandBackgroundInverted,
  },
  header: {
    height: 'auto',
  },
});
